(function($) {
  if (window.TL.Announce === undefined) {
    window.TL.Announce = {}
  }

  /**
   * Corner
   * @since 2019-10-11
   */
  var Corner = {
    _default: {
      showClass: 'show',
      dismiss: '.dismiss',
    },
    init(element, options) {
      var el = this._getElement(element)
      var opts = {
        ...this._default,
        ...options
      }
      el.Corner = opts
      return el;
    },
    show(element) {
      var el = this._getElement(element)
      if (!el) return;
      var data = el.Corner
      if (!data) {
        data = this._default
        this._setProperties(el, data)
      }
      el.classList.add(data.showClass)

      var dismiss = el.querySelector(data.dismiss)
      if (dismiss) {
        el.querySelector(data.dismiss).addEventListener('click', event => {
          this.remove(el)
        })
      }
      return el;
    },
    hide(element) {
      var el = this._getElement(element)
      var data = el.Corner
      el.classList.remove(data.showClass)
    },
    remove(element) {
      var el = this._getElement(element)
      el.parentNode.removeChild(el)
    },
    _getElement(element) {
      var el = element
      if (typeof element === 'string') {
        el = document.querySelector(element)
      }
      return el;
    },
    _setProperties(element, object) {
      var el = this._getElement(element)
      el.Corner = object
    }
  }

  if (window.TL.Announce.corner === undefined) {
    window.TL.Announce.corner = Corner;
  }

  /**
   * Topbar
   * @since 2019-10-11
   */
  var Topbar = {
    _default: {
      duration: 400,
      dismiss: '.dismiss'
    },
    init(element, options) {
      var el = this._getElement(element)
      var opts = {
        ...this._default,
        ...options
      }
      el.Topbar = opts
      return el
    },
    show(element, duration) {
      var el = this._getElement(element)
      if (!el) return;
      var data = el.hasOwnProperty('Topbar')
      if (!data) {
        data = this._default
        el.Topbar = data
      }
      var d = el.Topbar.duration
      var h = $(el).outerHeight()
      $(el).slideDown(d)
      $('body').animate({
        marginTop: h
      }, d)

      var dismiss = el.querySelector(data.dismiss)
      if (dismiss) {
        dismiss.addEventListener('click', event => {
          this.remove(el)
        })
      }
    },
    hide(element, duration) {
      var el = this._getElement(element)
      if (el) {
      var d = duration || el.Topbar.duration
        $(el).slideUp(d)
        $('body').animate({
          marginTop: 0
        }, d, function() {
          $('body').css('margin-top', '')
        })
      }
    },
    remove(element, duration) {
      var el = this._getElement(element)
      if (el) {
        var d = duration || el.Topbar.duration
        this.hide(el, d)
        setTimeout(() => {
          el.parentNode.removeChild(el)
        }, d)
      }
    },
    _getElement(element) {
      var el = element
      if (typeof element === 'string') {
        el = document.querySelector(element)
      }
      return el;
    },
    _setProperties(element, object) {
      var el = this._getElement(element)
      el.Corner = object
    }
  }

  if (window.TL.Announce.topbar === undefined) {
    window.TL.Announce.topbar = Topbar;
  }
})(jQuery);